import { FORM_COLOR } from '@app/constant/ColorDefault'
import FormHelperText from '@mui/material/FormHelperText'
import { styled } from '@mui/material/styles'

const ErrorMessage = styled(FormHelperText)({
  color: FORM_COLOR.REQUIRED_ERROR,
  paddingLeft: 14,
})

export default ErrorMessage
